const MdsUniqueId = {
    methods: {
        generateUuid(elementName) {
            let uuidValue = '',
                randomValue,
                timestamp;

            for (let k = 0; k < 32; k++) {
                timestamp = new Date().getTime();
                randomValue = (timestamp + Math.random() * 16) % 16 | 0;

                if (k === 8 || k === 12 || k === 16 || k === 20) {
                    uuidValue += '-' + ((randomValue & 3) | 8).toString(16);
                } else {
                    uuidValue += randomValue.toString(16);
                }
            }
            return `${elementName}-${uuidValue}`;
        },
    },
};

export default MdsUniqueId;
